import { persistTimezone, readStoredTimezone, resolveInitialTimezone } from "@/lib/timezone";
import { type ReactNode, createContext, useContext, useState } from "react";

interface TimezoneContextValue {
  timezone: string;
  setTimezone: (tz: string) => void;
}

const TimezoneContext = createContext<TimezoneContextValue | undefined>(undefined);

// 사용자가 고른 표시 timezone. localStorage 에만 저장되는 FE 전용 설정이라
// 백엔드/네트워크 의존성이 없고, 변경 시 화면이 즉시 다시 렌더된다.
export function TimezoneProvider({ children }: { children: ReactNode }) {
  const [timezone, setTimezoneState] = useState<string>(() =>
    resolveInitialTimezone(readStoredTimezone())
  );

  const setTimezone = (tz: string): void => {
    setTimezoneState(tz);
    persistTimezone(tz);
  };

  return (
    <TimezoneContext.Provider value={{ timezone, setTimezone }}>
      {children}
    </TimezoneContext.Provider>
  );
}

export function useTimezone() {
  const ctx = useContext(TimezoneContext);
  if (ctx === undefined) throw new Error("useTimezone must be used within a TimezoneProvider");
  return ctx;
}
